import React from 'react';
import './Footer.css';

const Footer = () => {
    return (
        <footer className="footer">
            {/* Large Watermark Background */}
            <div className="footer__watermark">
                <span>SENTINEL-X</span>
            </div>

            <div className="footer__container container">
                {/* Main Footer */}
                <div className="footer__main">
                    {/* Brand */}
                    <div className="footer__brand">
                        <a href="#home" className="footer__logo">
                            <div className="footer__logo-icon">
                                <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M16 2L28 8V16C28 22.6274 22.6274 28 16 28C9.37258 28 4 22.6274 4 16V8L16 2Z"
                                        stroke="currentColor" strokeWidth="2" fill="none" />
                                    <path d="M16 8L22 11V16C22 19.3137 19.3137 22 16 22C12.6863 22 10 19.3137 10 16V11L16 8Z"
                                        fill="currentColor" />
                                </svg>
                            </div>
                            <span className="footer__logo-text">
                                Sentinel<span className="footer__logo-x">-X</span>
                            </span>
                        </a>
                        <p className="footer__tagline">
                            Open-source AI-powered WAF. Free forever. Build the future of web security together.
                        </p>
                        <div className="footer__social">
                            <a
                                href="https://github.com/NOTANHUMAN-00/security-ai"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="footer__social-link"
                                aria-label="GitHub"
                            >
                                <svg viewBox="0 0 24 24" fill="currentColor">
                                    <path d="M12 0C5.37 0 0 5.37 0 12c0 5.31 3.435 9.795 8.205 11.385.6.105.825-.255.825-.57 0-.285-.015-1.23-.015-2.235-3.015.555-3.795-.735-4.035-1.41-.135-.345-.72-1.41-1.23-1.695-.42-.225-1.02-.78-.015-.795.945-.015 1.62.87 1.845 1.23 1.08 1.815 2.805 1.305 3.495.99.105-.78.42-1.305.765-1.605-2.67-.3-5.46-1.335-5.46-5.925 0-1.305.465-2.385 1.23-3.225-.12-.3-.54-1.53.12-3.18 0 0 1.005-.315 3.3 1.23.96-.27 1.98-.405 3-.405s2.04.135 3 .405c2.295-1.56 3.3-1.23 3.3-1.23.66 1.65.24 2.88.12 3.18.765.84 1.23 1.905 1.23 3.225 0 4.605-2.805 5.625-5.475 5.925.435.375.81 1.095.81 2.22 0 1.605-.015 2.895-.015 3.3 0 .315.225.69.825.57A12.02 12.02 0 0024 12c0-6.63-5.37-12-12-12z" />
                                </svg>
                            </a>
                            <a
                                href="https://github.com/NOTANHUMAN-00/security-ai"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="footer__social-link"
                                aria-label="Twitter"
                            >
                                <svg viewBox="0 0 24 24" fill="currentColor">
                                    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
                                </svg>
                            </a>
                            <a
                                href="https://github.com/NOTANHUMAN-00/security-ai"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="footer__social-link"
                                aria-label="LinkedIn"
                            >
                                <svg viewBox="0 0 24 24" fill="currentColor">
                                    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
                                </svg>
                            </a>
                            <a
                                href="https://github.com/NOTANHUMAN-00/security-ai"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="footer__social-link"
                                aria-label="Discord"
                            >
                                <svg viewBox="0 0 24 24" fill="currentColor">
                                    <path d="M20.317 4.37a19.791 19.791 0 0 0-4.885-1.515.074.074 0 0 0-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 0 0-5.487 0 12.64 12.64 0 0 0-.617-1.25.077.077 0 0 0-.079-.037A19.736 19.736 0 0 0 3.677 4.37a.07.07 0 0 0-.032.027C.533 9.046-.32 13.58.099 18.057a.082.082 0 0 0 .031.057 19.9 19.9 0 0 0 5.993 3.03.078.078 0 0 0 .084-.028 14.09 14.09 0 0 0 1.226-1.994.076.076 0 0 0-.041-.106 13.107 13.107 0 0 1-1.872-.892.077.077 0 0 1-.008-.128 10.2 10.2 0 0 0 .372-.292.074.074 0 0 1 .077-.01c3.928 1.793 8.18 1.793 12.062 0a.074.074 0 0 1 .078.01c.12.098.246.198.373.292a.077.077 0 0 1-.006.127 12.299 12.299 0 0 1-1.873.892.077.077 0 0 0-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 0 0 .084.028 19.839 19.839 0 0 0 6.002-3.03.077.077 0 0 0 .032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 0 0-.031-.03zM8.02 15.33c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.956-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.956 2.418-2.157 2.418zm7.975 0c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.955-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.946 2.418-2.157 2.418z" />
                                </svg>
                            </a>
                        </div>
                    </div>

                    {/* Links */}
                    <div className="footer__links">
                        <div className="footer__column">
                            <h4 className="footer__column-title">Product</h4>
                            <ul className="footer__list">
                                <li><a href="#features">Features</a></li>
                                <li><a href="#pricing">Pricing</a></li>
                                <li><a href="#enterprise">Enterprise</a></li>
                                <li><a href="#changelog">Changelog</a></li>
                            </ul>
                        </div>
                        <div className="footer__column">
                            <h4 className="footer__column-title">Resources</h4>
                            <ul className="footer__list">
                                <li><a href="#docs">Documentation</a></li>
                                <li><a href="#api">API Reference</a></li>
                                <li><a href="#guides">Guides</a></li>
                                <li><a href="#blog">Blog</a></li>
                            </ul>
                        </div>
                        <div className="footer__column">
                            <h4 className="footer__column-title">Company</h4>
                            <ul className="footer__list">
                                <li><a href="#about">About</a></li>
                                <li><a href="#careers">Careers</a></li>
                                <li><a href="#contact">Contact</a></li>
                                <li><a href="#press">Press Kit</a></li>
                            </ul>
                        </div>
                        <div className="footer__column">
                            <h4 className="footer__column-title">Legal</h4>
                            <ul className="footer__list">
                                <li><a href="#privacy">Privacy Policy</a></li>
                                <li><a href="#terms">Terms of Service</a></li>
                                <li><a href="#security">Security</a></li>
                                <li><a href="#gdpr">GDPR</a></li>
                            </ul>
                        </div>
                    </div>
                </div>

                {/* Divider */}
                <div className="footer__divider"></div>

                {/* Bottom */}
                <div className="footer__bottom">
                    <p className="footer__copyright">
                        © 2026 Y-NINE LABS. Open Source under MIT License.
                    </p>
                    <div className="footer__status">
                        <span className="footer__status-dot"></span>
                        All systems operational
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
